import * as React from "react";
const SvgPitchPerfect = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9.827 7.14a.75.75 0 0 0-.918-.53A3.25 3.25 0 1 0 13 9.75a.75.75 0 0 0-.75-.75h-1.925l-.498-1.86ZM8.473 8.554c.045-.048.093-.094.143-.136l.41 1.527a.75.75 0 0 0 .724.556h1.581a1.75 1.75 0 1 1-2.858-1.946ZM13 6.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM15.75 8.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
      fill="currentColor"
    />
    <path
      d="M12.75 2.75a.75.75 0 0 0-1.5 0V3h-7.5a.75.75 0 0 0-.75.75V14.5h-.25a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h4.005l-.727 2.544a.75.75 0 0 0 1.442.412l.845-2.956h2.935v2.25a.75.75 0 0 0 1.5 0V18.5h2.935l.844 2.956a.75.75 0 0 0 1.443-.412l-.727-2.544h4.005a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75H21V3.75a.75.75 0 0 0-.75-.75h-7.5v-.25ZM16.237 17H3.5v-1h17v1h-4.263ZM4.5 4.5h15v10h-15v-10Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPitchPerfect;
